/**
 * copy collector'i (opsiyonel).
 * Kopyalanan metnin turu raporlanir (telefon, IBAN, kupon, e-posta);
 * ham metin hicbir zaman gonderilmez.
 */
import { AUTO_EVENTS } from "../events";

const IBAN_REGEX = /\b[A-Z]{2}\d{2}[A-Z0-9]{10,30}\b/i;
const PHONE_REGEX = /(\+?\d[\d\s().-]{8,17}\d)/;
const EMAIL_REGEX = /[^\s@]+@[^\s@]+\.[^\s@]+/;
const COUPON_REGEX = /^[A-Z0-9]{4,20}$/;

function classify(text) {
    const trimmed = text.trim();
    if (!trimmed) return "";
    if (IBAN_REGEX.test(trimmed.replace(/\s/g, ""))) return "iban";
    if (EMAIL_REGEX.test(trimmed)) return "email";
    if (PHONE_REGEX.test(trimmed) && trimmed.replace(/[^\d]/g, "").length >= 10) return "phone";
    if (COUPON_REGEX.test(trimmed)) return "coupon";
    return "other";
}

class CopyCollector {
    constructor(tracker) {
        this.tracker = tracker;
    }

    start() {
        const self = this;
        document.addEventListener("copy", function () {
            try {
                const selection = window.getSelection ? String(window.getSelection()) : "";
                if (!selection) return;
                const kind = classify(selection);
                if (!kind) return;
                self.tracker.emit(AUTO_EVENTS.COPY, {
                    content_type: kind,
                    length: selection.length,
                });
            } catch (e) {
                /* yoksay */
            }
        });
    }
}

export default CopyCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/copy.js
// module id = null
// module chunks = 